import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';

import webClient from '../../core/web_client';
import { ITEM_PRICE_LIST_PATH } from '../../core/constants';
import { extractErrorData, extractResponseData } from '../../core/utils/api_utils';
import { DEFAULT_STATE, STATE__API__FAIL, STATE__API__STARTED, STATE__API__SUCCESS } from '../../core/utils/store_utils';
import { invalidateToken } from '../authorization/get_token';

export const deleteItemPriceListAction = createAsyncThunk(
    'price/deleteItemPriceListAction',
    async (data, { fulfillWithValue, rejectWithValue }) => {
        try {
            const response = await webClient.delete(`${ ITEM_PRICE_LIST_PATH }/${ data.productId }/price-list/${ data.priceListId }`);
            return fulfillWithValue(extractResponseData(response));
        } catch (error) {
            return rejectWithValue(extractErrorData(error));
        }
    }
);

const deleteItemPriceListSlice = createSlice({
    name: 'deleteItemPriceListSlice',
    initialState: DEFAULT_STATE,
    reducers: {},
    extraReducers: builder => {
        builder.addCase(deleteItemPriceListAction.pending, () => STATE__API__STARTED);
        builder.addCase(deleteItemPriceListAction.fulfilled, (_, { payload }) => STATE__API__SUCCESS(payload));
        builder.addCase(deleteItemPriceListAction.rejected, (_, { payload }) => STATE__API__FAIL(payload));
        builder.addCase(invalidateToken, () => DEFAULT_STATE);
    }
});

export const deleteItemPriceListState = (state) => state.price.deleteItemPriceList;
export default deleteItemPriceListSlice.reducer;
